import styled, { css } from 'styled-components';
import { Size } from '../types';
import { BOXSHADOWS, COLORS, ComponentTextStyle, focusStyles } from '../styles';
import { ComponentMStyling, ComponentSStyling, ComponentXSStyling } from '../styles/typography';
import { Z_INDEXES } from '../styles/z-indexes';

const distanceToEdge = (size: Size | undefined) => {
  return size == Size.XSmall ? '8px' : !size || size == Size.Small ? '12px' : '16px';
};

export const Tooltip = styled.div<{
  $withArrow?: boolean;
  $size?: Size;
  $height?: string;
  $maxWidth?: string;
  $align?: 'start' | 'end' | 'center' | undefined;
  $position?: 'top' | 'right' | 'bottom' | 'left' | undefined;
  $width?: string;
}>`
  pointer-events: none;
  color: ${props => COLORS.generateToken({ componentType: 'text', isOnFill: true, defaultVariant: 'default' }, props.theme)};
  ${(props) => (props.$size == Size.Small || props.$size != Size.Medium ? ComponentSStyling(ComponentTextStyle.Regular, null) : '')}
  ${(props) => (props.$size == Size.XSmall ? ComponentXSStyling(ComponentTextStyle.Regular, null) : '')}
    ${(props) => (props.$size == Size.Medium ? ComponentMStyling(ComponentTextStyle.Regular, null) : '')}
    ${(props) => (props.$align == 'center' ? 'text-align: center;' : '')}
    box-shadow: ${BOXSHADOWS.BOXSHADOW_L2};
  box-sizing: border-box;

  padding: ${(props) => (props.$size == Size.XSmall ? '4px 8px' : props.$size == Size.Medium ? '8px 12px' : '6px 10px')};
  border-radius: 2px;
  ${(props) => (props.$width ? `width: ${props.$width};` : 'width: max-content;')}
  height: ${(props) => props.$height};
  max-width: ${(props) => props.$maxWidth ?? '34em'};
  background: ${props => COLORS.generateToken({ componentType: 'bg-fill', defaultVariant: 'default' }, props.theme)};
  position: absolute;
  opacity: 0;
  z-index: ${Z_INDEXES.tooltip};
  ${(props) => (props.$position == 'top' ? 'bottom: 110%;' : props.$position == 'bottom' ? 'top: 110%;' : '')}

  ${(props) => (props.$position == 'left' ? 'bottom: 50%; transform: translateX(-110%) translateY(50%);' : '')}
    ${(props) => (props.$position == 'right' ? 'bottom: 50%;left: 110%; transform: translateY(50%);' : '')}
            
    ${(props) =>
    props.$position == 'left' || props.$position == 'right'
      ? ''
      : props.$align == 'start'
      ? 'left: 0%;'
      : props.$align == 'end'
      ? 'right: 0%;'
      : 'left: 50%; transform: translateX(-50%);'}


&::after {
    ${(props) => (!props.$withArrow ? 'display: none;' : '')}
    content: "";
    position: absolute;
    ${(props) => (props.$position == 'top' ? 'top: 100%;' : props.$position == 'bottom' ? 'bottom: 100%;' : '')}

    ${(props) => (props.$position == 'right' ? 'right: 100%; bottom: 50%; transform: translateY(50%);' : '')}
    ${(props) => (props.$position == 'left' ? 'left: 100%; bottom: 50%; transform: translateY(50%);' : '')}

    ${(props) =>
      props.$position == 'left' || props.$position == 'right'
        ? ''
        : props.$align == 'start'
        ? `left: ${distanceToEdge(props.$size)};`
        : props.$align == 'end'
        ? `right: ${distanceToEdge(props.$size)};`
        : 'left: 50%;'}

    ${(props) => (props.$position == 'left' ? '' : 'margin-left: -5px;')}
    margin: -0.5px;
    border-width: 4px;
    border-style: solid;
    border-color: ${(props) => (props.$position == 'top' ? COLORS.generateToken({ componentType: 'bg-fill', defaultVariant: 'default' }, props.theme) : 'transparent')} 
      ${(props) => (props.$position == 'right' ? COLORS.generateToken({ componentType: 'bg-fill', defaultVariant: 'default' }, props.theme) : 'transparent')}
      ${(props) => (props.$position == 'bottom' ? COLORS.generateToken({ componentType: 'bg-fill', defaultVariant: 'default' }, props.theme) : 'transparent')} 
      ${(props) => (props.$position == 'left' ? COLORS.generateToken({ componentType: 'bg-fill', defaultVariant: 'default' }, props.theme) : 'transparent')};
  }

  & > span {
    word-wrap: break-word;
    color: white;
  }
`;

Tooltip.defaultProps = {
  $withArrow: false,
  $size: Size.Small,
  $height: 'auto',
  $align: 'center',
  $position: 'bottom',
};

export const TooltipTrigger = (triggerType: 'hover' | 'click', delay?: string) => css`
  ${triggerType == 'hover'
    ? `&:hover ${Tooltip}, &:focus-within ${Tooltip}, &:focus ${Tooltip} {
      opacity: 1;
      transition: 0.5s;
    transition-delay: ${delay ?? '0.7s'};
    }`
    : `& ${Tooltip} {
      transition: 0.5s;
      transition-delay: ${delay ?? '0s'};
    }
  
    &.show ${Tooltip} {
      opacity: 1;
    }
  
    &.hide ${Tooltip} {
      opacity: 0;
    }`}
`;

export const TooltipContainer = styled.div<{ $triggerType: 'hover' | 'click', $delay?: string }>`
  display: inline-block;
  position: relative;

  ${(props) => TooltipTrigger(props.$triggerType, props.$delay)}

  &:focus {
    ${focusStyles}
  }
`;
